import React from 'react';
import Layout from 'components/layout';
import Header from 'sections/header-subpage';
import EmployeeSection from 'sections/team';
import FooterSection from 'sections/footer';
import Markdown from 'sections/markdown';
import SEO from 'components/seo';
import { useTranslation } from 'react-i18next';

const AboutTemplate = props => {
  const [t] = useTranslation();
  const { seoTitle, seoDescription, data } = props;
  const { strapiPages = {} } = data;

  return (
    <Layout>
      <SEO title={seoTitle} description={seoDescription} />
      <Header
        title={t('page--about.heading')}
        subtitle={t('page--about.subheading')}
        image={strapiPages && strapiPages.headerImage}
        hideCTA={true}
      />
      <Markdown source={t('page--about.content')} />
      <EmployeeSection />
      <FooterSection />
    </Layout>
  );
};

export default AboutTemplate;
